/**
 * 校验工具：与 original BaseUtils 一致，供 trait 配置的 rules 在运行时用 async-validator 执行
 */
import Schema from "async-validator";

/** 将字符串转为 RegExp（支持 /pattern/ 形式） */
function stringToRegPattern(pattern: string): RegExp | null {
  if (!pattern || typeof pattern !== "string") return null;
  try {
    let s = pattern.trim();
    if (s.startsWith("/") && s.endsWith("/")) s = s.slice(1, -1);
    return new RegExp(s);
  } catch {
    return null;
  }
}

/**
 * 处理 trait 表格规则：将 pattern 字符串转为 RegExp，得到 async-validator 可用的规则数组
 */
export function processValidationRules(rules: any[]): any[] {
  if (!rules || !Array.isArray(rules)) return [];
  return rules.map((rule) => {
    const r = { ...rule };
    if (r.pattern && typeof r.pattern === "string" && r.pattern.trim()) {
      const re = stringToRegPattern(r.pattern);
      if (re) r.pattern = re;
      else delete r.pattern;
    }
    return r;
  });
}

const FIELD = "_v";

/**
 * 用 async-validator 校验单个值（与 original validateData 等价）
 * @param rules 已通过 processValidationRules 处理后的规则数组
 * @param value 待校验值
 * @param onSuccess 通过时调用
 * @param onError 失败时调用，参数为 errors（取第一条 message 即可）
 */
export function validateWithSchema(
  rules: any[],
  value: unknown,
  onSuccess: () => void,
  onError: (errors: Array<{ message?: string }>) => void
): void {
  if (!rules?.length) {
    onSuccess();
    return;
  }
  const descriptor = { [FIELD]: rules };
  const validator = new Schema(descriptor);
  validator
    .validate({ [FIELD]: value }, { first: true })
    .then(() => {
      onSuccess();
    })
    .catch(({ errors }: { errors: Array<{ message?: string }> }) => {
      onError(errors || []);
    });
}
